// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__b8i67","Cell":"EmployeeTable_Cell__KHIuy","Paper":"EmployeeTable_Paper__raat+"};